<div class="price-table-container">
  <table mat-table [dataSource]="displayedScenarios()">
    <ng-container matColumnDef="Scenario ID">
      <th mat-header-cell *matHeaderCellDef>Scenario ID</th>
      <td mat-cell *matCellDef="let scenario" class="nowrap" matTooltip="{{getScenarioKey(scenario)}}" matTooltipPosition="right">
        {{ excerpt(getScenarioKey(scenario), 19) }}
      </td>
    </ng-container>

    @for(year of years(); track year) {
      <ng-container matColumnDef="{{ year }}">
        <th mat-header-cell *matHeaderCellDef>{{ year }}</th>
        <td mat-cell *matCellDef="let scenario">
          @if(scenario.pricePerYear[year]) {
            {{
              scenario.pricePerYear[year] * forecastRate(year)
                | number : '0.0-1'
            }}
          } @else if(scenario.historicalPricePerYear[year]) {
            {{
              scenario.historicalPricePerYear[year] * historicalRate(year)
                | number : '0.0-1'
            }}
          }
        </td>
      </ng-container>
    }


    <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td colspan="16" class="no-data-message">
        Select at least one scenario to display prices data
      </td>
    </tr>
  </table>
</div>
